module.exports = __webpack_public_path__ + "media/widgets/niche-no-essay_1300x1300_@2x-96421fe7.png";